import React, { useEffect, useCallback, useState} from 'react';
import {useThemes} from "components/v3/themes/useThemes.js"
import {AUDIO} from 'constants/track-types.js';
import EffectPresets from "components/effects/EffectPresets.js";
import {getEffectTrack} from "utils/getEffectTrack.js";
import PadPacks from "components/sidebar/PadPacks.js";
import PresetsExplorer from "components/installation/PresetsExplorer.js";
import {EFFECT, ZOBJECT, ZMESSAGE, PAD, TRACK} from 'constants/object-types.js';
import {connect} from 'react-redux';
import SamplesStreamExplorer from "components/sidebar/SamplesStreamExplorer.js";

import './audition.scss';

const AuditionSidebar = ({object, sequencerEngine}) => { 
//    useThemes();
    let inner = '';
    if (object.getObjectType() === TRACK) {
        if (object.getTrackType() === AUDIO) {
            return '';
        }
        if (object.sample) {
            return (
                <SamplesStreamExplorer isPianoRoll={true} track={object}/>
            );
        } else {
            let track = object;
            let type = track.instrument ? track.instrument.getInstrumentType() :
            track.getTrackType();
            return (
                <PresetsExplorer
                  isPianoRoll={false}
                  initialSize={18}
                  track={object}
                  content={object.preset}
                  searchText={""}
                  type={type}/>
            );
        }
    } else if (object.getObjectType() === PAD) {
        return (<PadPacks pad={object}/>);
    } else if (object.getObjectType() === ZOBJECT) {
        return (
            <PresetsExplorer
              initialSize={18}
              zobject={object}
              content={object.preset}
              searchText={""}
              type={object.getInstrumentType()}/>);
    } else if (object.getObjectType() === EFFECT) {
        let track = getEffectTrack(object);
        if (track) {
            return (
                <EffectPresets
                  sequencerEngine={sequencerEngine}
                  trackNumber={track.trackNumber}
                  hide={() => 0}
                  effect={object}
                />
            );
        }
    }

    return (
        <div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      namme: props.object.name,
      preset: props.object.preset && props.object.preset.contentHash
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuditionSidebar);
